import styled, { css } from 'styled-components';

interface WrapperProps {
  isCurrentAddress: boolean;
  isSelected: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  ${({ theme, isCurrentAddress, isSelected }) => css`
    display: grid;
    ${isSelected &&
    css`
      grid-template-columns: auto ${isCurrentAddress ? '40px' : '80px'};
    `}
    width: 100%;
    cursor: pointer;

    > div {
      &:first-of-type {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        border-radius: 8px;
        border: 1px solid
          ${isCurrentAddress ? theme.colors.green2 : theme.colors.grey5};

        > div {
          &:first-of-type {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
          }

          &:last-of-type {
            display: flex;
            justify-content: center;
            transform: ${isSelected ? 'rotate(-90deg)' : 'rotate(0deg)'};
            transition: transform 0.4s;
            cursor: pointer;
          }
        }
      }

      &:last-of-type {
        display: flex;
        align-items: center;

        svg {
          margin-left: 16px;
          cursor: pointer;
        }
      }
    }
  `}
`;
